import * as io from "io-ts";
import { nullable } from "diagnostics-lib/io";
import createGlobalState from "@ui/lib/createGlobalState";

const useHoveredAnalysis = createGlobalState({
  storage: "memory",
  key: "hoveredAnalysis",
  type: nullable(io.string),
  defaultValue: null,
  scoped: false,
});

export default useHoveredAnalysis;
